import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type LinkBroken01IconProps = IconProps

const LinkBroken01Icon = forwardRef<SVGSVGElement, LinkBroken01IconProps>(
  (props: LinkBroken01IconProps, ref) => (
    <Icon {...props} ref={ref}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9 4V2m6 18v2M4 9H2m18 6h2M4.914 4.914 3.5 3.5m15.586 15.586L20.5 20.5M12 17.657l-2.121 2.121a4 4 0 1 1-5.657-5.657L6.343 12m11.314 0 2.121-2.121a4 4 0 1 0-5.657-5.657L12 6.343"
        fill="none"
      ></path>
    </Icon>
  ),
)

LinkBroken01Icon.displayName = 'LinkBroken01Icon'
LinkBroken01Icon.defaultProps = iconDefaultProps

export type { LinkBroken01IconProps }
export { LinkBroken01Icon }
